const AreYouSureIcon = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
      >
        <g clipPath="url(#clip0_233_10565)">
          <path
            d="M32 0C14.3136 0 0 14.312 0 32C0 49.6861 14.312 64 32 64C49.6864 64 64 49.688 64 32C64 14.3136 49.688 0 32 0ZM31.0531 46.9774C29.2419 46.9774 27.8519 45.461 27.8519 43.7339C27.8519 41.9648 29.284 40.4906 31.0531 40.4906C32.8224 40.4906 34.2964 41.9649 34.2964 43.734C34.2964 45.4609 32.8643 46.9774 31.0531 46.9774ZM35.8549 30.592C33.5382 32.4032 33.496 33.6669 33.496 35.8571C33.496 36.6576 33.0747 37.5843 31.0109 37.5843C29.2838 37.5843 28.6943 36.9524 28.6943 34.7621C28.6943 31.1396 30.2949 29.4126 31.5164 28.3596C32.9064 27.1801 35.2653 25.8745 35.2653 23.6C35.2653 21.6623 33.5804 20.7356 31.4743 20.7356C27.1779 20.7356 28.1046 23.9791 25.8299 23.9791C24.6926 23.9791 23.3026 23.2208 23.3026 21.5781C23.3026 19.3036 25.9141 15.9338 31.6006 15.9338C36.9921 15.9338 40.5725 18.9245 40.5725 22.8839C40.5725 26.8433 36.9921 29.7075 35.8549 30.592Z"
            fill="#E62D38"
          />
        </g>
        <defs>
          <clipPath id="clip0_233_10565">
            <rect width="64" height="64" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};
export default AreYouSureIcon;
